import { render, staticRenderFns } from "./project-planification.vue?vue&type=template&id=b4ffba7a&"
import script from "./project-planification.vue?vue&type=script&lang=ts&"
export * from "./project-planification.vue?vue&type=script&lang=ts&"
import style0 from "./project-planification.vue?vue&type=style&index=0&id=b4ffba7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports